// extracted by mini-css-extract-plugin
module.exports = {"descriptionBlock":"ProfileInfo_descriptionBlock__3cd8Y","profileData":"ProfileInfo_profileData__18agI","socialNetContact":"ProfileInfo_socialNetContact__2DGo7"};